/**
 * 分时图鲸奇9转装饰器
 */
import {mergeModelData} from '../../../util/index.js';
const model = {
  jqRiseList: {
    Type: Array,
    Default: () => ([])
  },
  jqFallList: {
    Type: Array,
    Default: () => ([])
  }
};
const TrendJQJZDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    const {jqRiseList, jqFallList, start, end, last_px, sealObj} = this.state.data;
    const {basePx} = sealObj;
    const {height} = this.availArea;
    const baseSize = this.state.baseSize;
    const {
      sizeRatio,
      fontFamily,
    } = this.option.JQJZ;
    const {
      jqHeight,
      triangleWidth,
      verticalSpace,
    } = this.measureJQJZLabel({
      text: '9',
      fontSize: sizeRatio * baseSize * this.dpr,
      fontFamily
    });
    let maxValue = this.maxValue;
    let minValue = this.minValue;
    let _max = maxValue;
    let _min = minValue;
    let _tempMax = maxValue;
    let _tempMin = minValue;
    const _c = (verticalSpace + jqHeight + triangleWidth * 2) / height;
    const _rate = (maxValue - minValue) * _c;
    jqRiseList.filter(a => a.index >= start && a.index < end).forEach(item => {
      const val = last_px[item.index].value - _rate;
      if (val < _tempMin) {
        _tempMin = val;
        _min = last_px[item.index].value;
      }
    });
    jqFallList.filter(a => a.index >= start && a.index < end).forEach(item => {
      const val = last_px[item.index].value + _rate;
      if (val > _tempMax) {
        _tempMax = val;
        _max = last_px[item.index].value;
      }
    });
    if (_tempMax !== maxValue || _tempMin !== minValue) {
      maxValue = (_max - _min * _c - _max * _c) / (1 - 2 * _c);
      minValue = (_min - _max * _c - _min * _c) / (1 - 2 * _c);
      if (_tempMax - basePx > basePx - _tempMin) {
        minValue = 2 * basePx - maxValue;
      } else {
        maxValue = 2 * basePx - minValue;
      }
    }
    this.maxValue = maxValue;
    this.minValue = minValue;
    this.baseValue = basePx;
  }
  _drawMain() {
    super._drawMain();
    const {
      left,
      bottom,
      width
    } = this.availArea;
    const {last_px} = this.state.data;
    this._drawJQJZ(last_px, left, bottom, width);
  }
}

export default TrendJQJZDectorator;